






























import {Vue, Component} from 'vue-property-decorator';
import dataProxy from '@/services/data-proxy.service'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatInteger, formatPrice} from "@/utils/formatters";
import {F_izv_VratiPrejdeneKilometreVozilaIVozaca} from "@/services/BackendProxies";
import * as _ from 'lodash';
import {red, blue, yellow, green, lightBlue, purple, orange, black, pink} from '@/utils/colors';

@Component
export default class PredjeniKilometriVozacaIVozila extends mixins(ComponentBaseMixin) {
    columns = [];
    dataSource: F_izv_VratiPrejdeneKilometreVozilaIVozaca[] = [];
    chartData1 = {};
    chartData2 = {};
    chartOptions = {
        maintainAspectRatio: true,
        legend: {display: false},
    }
    loading = true;

    async created() {
        this.columns = [
            {field: 'registarskaOznaka', title: this.$i18n.t('registarskaOznaka'), width: 80},
            {field: 'markaIModelVozila', title: this.$i18n.t('markaIModel')},
            {field: 'vozac', title: this.$i18n.t('vozac'), width: 220},
            {field: 'predjeno', title: this.$i18n.t('predjeniKilometri'), formatter: formatInteger, width: 120, align: 'right', sortable: true},
            {field: 'ukupnoPredjeniKilometriVozila', title: this.$i18n.t('ukupnoPredjeniKilometriVozila'), formatter: formatInteger, width: 120, align: 'right', sortable: true},
            {field: 'procenat1', title: this.$i18n.t('ucesceUUkupnoPredjenimKilometrimaVozila'), formatter: formatPrice, width: 120, align: 'right', sortable: true},
            {field: 'procenat2', title: this.$i18n.t('ucesceUUkupnoPredjenimKilometrimaVoznogParka'), formatter: formatPrice, width: 120, align: 'right', sortable: true},
        ];
        try {
            this.loading = true;
            this.dataSource = await this.loadData(() => dataProxy.vratiPrejdeneKilometreVozilaIVozaca())();
            this.setChartData();
        } finally {
            this.loading = false;
        }
    }

    private setChartData() {
        this.setChartData1();
        this.setChartData2();
    }

    private setChartData1() {
        const g = _.groupBy(this.dataSource, 'registarskaOznaka');
        const normalized = _.flatMap(g, (value, key) => {
            return {registarskaOznaka: key, predjeno: _.sumBy(value, 'predjeno')}
        });
        const top10 = _.take(normalized.sort((a, b) => a.predjeno > b.predjeno ? -1 : 1), 10);
        this.chartData1 = {labels: top10.map(x => x.registarskaOznaka), datasets: [{backgroundColor: this.getColors(), data: top10.map(x => x.predjeno)}]};
    }

    private setChartData2() {
        const g = _.groupBy(this.dataSource, 'vozac');
        const normalized = _.flatMap(g, (value, key) => {
            return {vozac: key, predjeno: _.sumBy(value, 'predjeno')}
        });
        const top10 = _.take(normalized.sort((a, b) => a.predjeno > b.predjeno ? -1 : 1), 10);
        this.chartData2 = {labels: top10.map(x => x.vozac), datasets: [{backgroundColor: this.getColors(), data: top10.map(x => x.predjeno)}]};
    }

    private getColors() {
        return [blue, lightBlue, purple, green, yellow, orange, black, pink];
    }
}
